<template>
  <div style="height: 60px"></div>
  <div class="box-1 container flex">
    <el-image 
      style="width: 550px; height: 302px"
      :src="isHead(voteInfo.imgpath1)" 
      fit="cover">
      <el-image 
        style="width: 550px; height: 302px"
        :src="isHead()" 
        fit="cover">
      </el-image>
    </el-image>
    <div class="info-box flex-item">
      <div class="title">{{voteInfo.title}}</div>
      <div class="time">活动时间：{{formatTime(voteInfo.starttime, "YYYY-MM-DD HH:mm")}} 至 {{formatTime(voteInfo.endtime, "YYYY-MM-DD HH:mm")}}</div>

      <div class="count_down">
        <span v-if="countDown">{{countDown}}</span> 
      </div>
      <div class="setp flex">
        <div class="item" :class="[act_type >= 0 ? 'on' : '']">即将开始</div>
        <div class="item" :class="[act_type >= 1 ? 'on' : '']">投票中</div>
        <div class="item" :class="[act_type >= 2 ? 'on' : '']">投票结束</div>
      </div>
      <div style="height: 40px"></div>
      <el-button type="primary" class="startBtn" color="#1A2E43" @click="openQuestion()" >参与投票</el-button>
      <el-button type="info" class="startBtn"  @click="openRank()" >查看排行</el-button>
    </div>

  </div>

  <div style="height: 60px"></div>
  <div class="box-2" v-if="voteInfo.content">
    <div style="height: 60px"></div>
    <div class="container">
      <div class="content" v-html="Base64.decode(voteInfo.content)">
      </div>
    </div>
    <div style="height: 60px"></div>
  </div>

  <!-- 投票 -->
  <el-dialog
    v-model="voteVisible"
    title=""
    width="1260px"
    custom-class="aaaa"
  > 
    
    
    <div class="vote-box " v-for="v in voteData" :key="v.questionid">
      <div class="tips">{{v.question}}</div>
      <div class="box flex">
        <div class="items" v-for="item in v.items" :key="item.id">
          <div class="item">
            <div class="cover" @click="handleItem(item)">
              <el-image 
                style="width: 100%; height: 155px"
                :src="isHead(item.imgpath)" 
                fit="cover">
                <template #placeholder>
                  <el-image 
                    style="width: 100%; height: 155px"
                    :src="isHead()" 
                    fit="cover">
                  </el-image>
                </template>
              </el-image>
              <img class="play" :src="require('@/assets/5101/icon_11.png')" alt="" v-show="item.videopath">
              <!-- <div class="num">{{item.num}}</div> -->
              <el-tag class="ml-2" type="danger">{{item.num}} 票</el-tag>
            </div>
            
            <div class="bot-box">
              <div class="title ellipsis_2">{{item.item}}</div>
              <el-button type="warning" @click="postData(v, item)" :loading="item.loading">投一票</el-button>
            </div>
          </div>
        </div>
      </div>
        
      
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="voteVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 查看视频 -->
  <el-dialog
    v-model="videoVisible"
    title="视频详情"
    width="1040px"
  >
    <VideoPlayer :options="videoOptions" v-if="videoVisible" />

  </el-dialog>
  <!-- 查看图片 -->
  <el-dialog
    v-model="imgVisible"
    title="图片详情"
    width="1040px"
  >
    <img :src="isHead(imgPath)" alt="">

  </el-dialog>
  <!-- 排行榜 -->
  <el-dialog
    v-model="rankVisible"
    title="排行榜"
    width="1040px"
  >
    <el-table :data="rankData" v-loading="rankLoading"  stripe style="width: 100%" height="600">
      <el-table-column align="center" header-align="center" type="index" label="排行" width="180" />
      <el-table-column align="center" header-align="center" label="项" prop="item" width="180" />
      <el-table-column align="center" header-align="center" prop="votenum" label="得票" width="180" />
      <el-table-column align="center" />
    </el-table>

  </el-dialog>
</template>

<script>
import { reactive, toRefs, computed } from "vue"
import { api } from "@/api"
import { isHead, formatTime, count_down } from "@/tools"
import { ElMessage, ElNotification } from 'element-plus'

let Base64 = require('js-base64').Base64;

import VideoPlayer from "@/components/common/VideoPlayer"

export default {
  name: "voteItem",
  props: ['voteInfo', 'userid'],
  components: { VideoPlayer },
  setup(props) {
    let initData = reactive({
      userid: computed(() => {
        return props.userid
      }),
      voteInfo: props.voteInfo,

      countDown: "",    // 倒计时
      timer: "",        // 定时器
      act_type: -1,     // 0 未开始 1 进行中 2 已结束 --- 同时用于活动步骤
      serverTime: new Date().getTime(),

      voteVisible: false, // 显示表单

      voteData: "",

      now_img: "",

      // 视频
      videoVisible: false,
      videoOptions: "",
      // 投票
      imgVisible: false,
      imgPath: "",

      // postLoading: false,
      rankVisible: false,
      rankLoading: false,
      rankData: []


    })

    // 获取服务器时间
    api("get", "getSystemTime")
      .then(res => {
        if(res.code === 1200) {
          initData.serverTime = res.data
          isState()
        } else {
          isState()
        }
      })
      .catch(err => {
        isState()
      })
    // 时间判断
    function isState() {
      let now_time = initData.serverTime
      let time;
      let { starttime, endtime } = initData.voteInfo
      if(starttime > now_time) {
        initData.act_type = 0
        time = starttime - now_time
        initData.timer = setInterval(() => {
          time -= 1000
          if(time < 1000) {
            initData.countDown = ""
            initData.act_type = 1
            clearInterval(timer)
          } else {
            initData.countDown = "距离投票开始还有：" + count_down(time)
          }
        },1000)
        return
      }
      if(starttime < now_time && endtime> now_time) {
        initData.act_type = 1
        time = endtime- now_time
        initData.timer = setInterval(() => {
          time -= 1000
          if(time < 1000) {
            initData.countDown = ""
            initData.act_type = 2
            clearInterval(timer)
          } else {
            initData.countDown = "距离投票结束还有：" + count_down(time)
          }
        },1000)
        return
      }
      if(endtime< now_time) {
        initData.countDown = ""
        initData.act_type = 2
        return
      }
    }
    // 获取问卷
    getQuestion()
    function getQuestion() {
      let data = { 
        userid: initData.userid,
        voteid: initData.voteInfo.voteid, 
        pageSize: 150 
      };
      api("get", "getVoteQuesList", data).then(res => {
        if(res.code === 1200) {
          initData.voteData = res.data
        } 
      })
  
    }
    // 打开投票
    function openQuestion() {
      if(initData.userid === "anonymous") {
        ElMessage({
          message: '请登录后参与.',
          type: 'warning',
        })
        return
      } 
      initData.voteVisible = true
    }
    // 打开排行
    function openRank() {
      getRank()
      initData.rankVisible = true
    }
    // 获取排行
    function getRank() {
      initData.rankLoading = true
      api("get", "getVoteTopSum", {aid: initData.voteInfo.articleid})
        .then(res => {
          initData.rankLoading = false
          if(res.code === 1200) {
            initData.rankData = res.data
          }
        })
        
    }
    // 点击选项
    function handleItem(row) {
      if(row.videopath) {
        initData.videoOptions = {
          autoplay: true,
          controls: true,
          sources: [
            {
              src: row.videopath,
              type: "application/x-mpegURL"
            }
          ]
        }
        initData.videoVisible = true
      } else {
        initData.imgPath = row.imgpath
        initData.imgVisible = true
      }
      
    }
    // 投票
    function postData(v, item) {
      let formData = {
        articleid: initData.voteInfo.articleid,
        totalscore: 0,
        userid: initData.userid,
        question: [{
          questionid: v.questionid,
          item: [{itemid: item.id}],
          sorce: 0,
          answer: ""
        }],
        voteid: initData.voteInfo.voteid
      };
      item.loading = true
      api("post","postUserVote", formData)
        .then(res => {
          item.loading = false
          // initData.postLoading = false
          if (res.code === 1200) {
            item.num += 1
            ElMessage({
              message: '投票成功.',
              type: 'warning',
            })
          } else {
            ElNotification({
              title: '提示',
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(err => {
          item.loading = false
          // initData.postLoading = false
          ElNotification({
            title: '提示',
            message: '投票提交失败！请重新尝试.',
            type: 'error',
          })
        })
    }
    return {
      ...toRefs(initData),
      isHead,
      formatTime,
      Base64,
      openQuestion,
      openRank,
      handleItem,
      postData
    }
  }
}
</script>
<style>
.header {
  border-bottom: 2px solid #F6F6F6;
  box-sizing: border-box;
}
.aaaa .el-dialog__header {
  
    padding: 0 !important;
  
}
</style>
<style lang="less" scoped>
.info-box {
  margin-left: 30px;
  .title {
    font-size: 24px;
    font-weight: bold;
  }
  .time {
    font-size: 14px;
    color: #8C96A1;
    margin-top: 20px;
  }
  .address {
    font-size: 14px;
    color: #8C96A1;
    margin-top: 15px;
  }
  .count_down {
    height: 85px;
    display: flex;
    align-items: flex-end;
    span {
      font-size: 18px;
      color: #10BB58;
    }
  }
  .setp {
    margin-top: 15px;
    .item.on {
      background-image: url('~@/assets/5101/img_2.png');
      color: #fff;
    }
    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 166px;
      height: 54px;
      background-image: url('~@/assets/5101/img_1.png');
      background-size: 100% 100%;
      color: #8C96A1;
      position: relative;
      left: -12px;
      padding-left: 10px;
      line-height: 1;
      box-sizing: border-box;
      &:first-child {
        left: 0;
      }
    }
  }
  .startBtn {
    height: 38px;
    padding: 11px 50px;
  }
}
.box-2 {
  background-color: #F6F6F6;
  .container {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .content {
      margin-right: 30px;
      :deep(img) {
        max-width: 100% !important;
        height: auto !important;
      }
    }
  }
  .tip {
    font-size: 20px;
    font-weight: bold;
  }
}
.vote-box {
  .tips {
    padding: 10px;
    font-size: 16px;
    color: #585858;
    font-weight: bold;
  }
  .box {
    flex-wrap: wrap;
    .items {
      margin: 10px;
      .item {
        width: 285px;
        height: 260px;
        background-color: #F2F6F8;
        border-radius: 6px;
        overflow: hidden;
        font-size: 0;
        box-sizing: border-box;
        .cover {
          position: relative;
          .play {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
          }
          .el-tag {
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 1;
          }
        }
        .bot-box {
          height: 105px;
          padding: 10px 15px;
          box-sizing: border-box;
          position: relative;
          .title {
            font-size: 16px;
            
          }
          .el-button {
            padding: 8px 50px;
            position: absolute;
            left: 50%;
            bottom: 10px;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
}

</style>